(function () {
  'use strict';

  // ── Sticky CTA visibility ──────────────────────────
  var stickyBar = document.getElementById('evtStickyCta');
  if (!stickyBar) return;

  // Find the native add-to-cart / product form area
  var productForm = document.querySelector('product-form, [id^="product-form"], .product-form, form[action="/cart/add"]');
  var siteFooter  = document.querySelector('.site-footer, .footer, footer[role="contentinfo"]');

  function updateStickyBar() {
    if (!productForm) return;
    var formRect   = productForm.getBoundingClientRect();
    var pastForm   = formRect.bottom < 0;
    var nearFooter = siteFooter ? siteFooter.getBoundingClientRect().top < window.innerHeight : false;

    if (pastForm && !nearFooter) {
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }
  }

  window.addEventListener('scroll', updateStickyBar, { passive: true });
  updateStickyBar();
})();